import React, { useEffect, useState } from 'react'
import Topbar from './Topbar'
import Sidebar_component from './Sidebar_component'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import Datetime from 'react-datetime'

export default function My_activity() {

  const [selectedDate, setSelectedDate] = useState(new Date())
  const [tasks, setTasks] = useState([])
  const [loading, setLoading] = useState(false)
  const [membretype, setMembertype] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  useEffect(() => {
    let memtype = localStorage.getItem('membership_type');
    if (memtype === 'free') {
      setMembertype(true);
    }
  })

  // 📅 When date changes
  const handleDateChange = (date) => {
    setSelectedDate(date)
    fetchActivity(date)
  }

  // 🔄 Fetch activity by date
  const fetchActivity = async (date) => {
    setLoading(true)

    const formattedDate = date.toISOString().split('T')[0]

    try {
      const response = await fetch('activity_by_date.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          user_id: localStorage.getItem('member_id'), // logged in user
          date: formattedDate
        })
      })

      const data = await response.json()
      setTasks(data)
    } catch (error) {
      console.error(error)
      setTasks([])
    }

    setLoading(false)
  }

  // 📄 Download PDF
  const downloadPDF = () => {
    const doc = new jsPDF()

    doc.text('Daily Activity Report', 14, 15)
    doc.text(`Date of Report: ${selectedDate.toDateString()}`, 14, 25)
    doc.text(`Name: ${localStorage.getItem('membername')}`, 14, 35)

    autoTable(doc, {
      head: [['#', 'Task', 'Task Details', 'Start Time', 'End Time', 'Worked Time']],
      body: tasks.map((task, index) => ([
        index + 1,
        task.task_name,
        task.task_details,
        task.start_time,
        task.end_time,
        task.time_worked
      ])),
      startY: 45
    })

    doc.save('activity-report.pdf')
  }

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div>
      <Topbar toggleSidebar={toggleSidebar} />
      <Sidebar_component sidebarOpen={sidebarOpen} />

      <div className='vl_dsh_bodypart'>
        <div className='vl_alltab'>
          <h2 className='bigfonttabs'>Activity</h2>
        </div>
        <section className='vl_dsh_bodypart_section pos_rel'>
          <p className='normaltext'>Select a date from the date picker to see your activity on that date</p>
          <div className='fullwidth'>
            {/* 📅 Calendar */}
            <div className='date_holder'>
              <label className='datelabel'>Select Date:</label><br />
              <DatePicker
                selected={selectedDate}
                onChange={handleDateChange}
                maxDate={new Date()}
                dateFormat="yyyy-MM-dd"
                showYearDropdown
                showMonthDropdown
                dropdownMode="select"

                yearDropdownItemNumber={50}
                scrollableYearDropdown
              />
            </div>

            {/* 🔄 Loading */}
            {loading && <p>Loading activity...</p>}

            {/* ❌ No Activity */}
            {!loading && tasks.length === 0 && (
              <h3 class="notice_text visbleitem">No activity found for this day.</h3>
            )}

            {/* 📋 Activity List */}
            {tasks.length > 0 && (
              <>
                <table className="activity-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Task</th>
                      <th>Task Details</th>
                      <th>Start</th>
                      <th>End</th>
                      <th>Worked</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tasks.map((task, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{task.task_name}</td>
                        <td>{task.task_details}</td>
                        <td>{task.start_time}</td>
                        <td>{task.end_time}</td>
                        <td>{task.time_worked}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                {/* 📄 PDF Button */}
                <button className='downlaodBTN'
                  style={{ marginTop: '15px' }}
                  onClick={downloadPDF}
                >
                  Download PDF <i className='ri-download-2-fill'></i>
                </button>
              </>
            )}

          </div>
        </section>
      </div>
      {membretype && (
        <div className='vl_dsh_popup activebillpop'>
          <div className='alertbox'>
            <div className='alertheader'>
              <h3><i className='ri-alert-line'></i>Alert</h3>
            </div>

            <div className='contentarea'>
              <p>Please upgrade your membership to access this page</p>
            </div>
            <div className='alert_btns'>
              <button onClick={() => window.history.back()}>Back</button>
            </div>

          </div>
        </div>
      )}
    </div>
  )
}
